import { authStorage } from '~/lib/authStorage';
import { hasTeamRole } from '~/lib/utils';

export const useUser = defineStore('useUser', {
  state: () => ({
    user: {
      roles: []
    },
    mode: 'park',
    favorites: [],
    features: [],
    access_token: '',
    refresh_token: '',
    ownerId: '',
    termsAndConditions: false,
  }),
  actions: {
    setUser(user) {
      this.user = user;
    },
    setRoles(roles) {
      if (this.user && Array.isArray(roles)) {
        this.user.roles = roles;
        if (!hasTeamRole(roles)) this.mode = 'park';
      }
    },
    setMode(mode) {
      this.mode = mode === 'lots' && hasTeamRole(this.user?.roles) ? 'lots' : 'park';
    },
    updateUser(user) {
      this.user.first_name = user.firstName;
      this.user.last_name = user.lastName;
      this.user.phone = user.phone;
      this.user.avatar = user?.avatar;
    },
    setFavorites(favorites) {
      this.favorites = favorites;
    },
    setFeatures(features) {
      this.features = features;
    },
    setOwnerId(ownerId) {
      this.ownerId = ownerId;
    },
    setTokens(access_token, refresh_token) {
      this.access_token = access_token;
      this.refresh_token = refresh_token;
    },
    setHasAcceptedTermsAndConditions(agreed) {
      this.termsAndConditions = agreed;
    }
  },
  getters: {
    getUser: (state) => state.user,
    getRoles: (state) => state.user?.roles ?? [],
    hasTeamRole: (state) => hasTeamRole(state.user?.roles),
    inLotsMode: (state) => state.mode === 'lots' && hasTeamRole(state.user?.roles),
    getUserFavorites: (state) => state.favorites,
    getUserFeatures: (state) => state.features,
    hasFeature: (state) => {
      return (feature) => state?.features?.includes(feature)
    },
    acceptedTermsAndConditions: (state) => state.termsAndConditions,
  },
  persist: {
    storage: authStorage
  },
})
